import Row from "common/Row/Row";
import React from "react";
import labels from "utils/LocalizedStrings";
import {
  formatDOB,
  getAnnuitantCityStateZip,
  getCityStateZip,
  getGender,
  maskSSN,
} from "utils/Utilities";

export const jointLifeInfo = (data, showSSN) => {
  return [
    {
      label: "jointLifeName",
      value: data?.electionChoice
        ? `${data?.annuitantFirstName} ${data?.annuitantMiddleName || ""} ${
            data?.annuitantLastName
          }`
        : `${data?.firstName} ${data?.middleName} ${data?.lastName}`,
    },
    {
      label: "ssn",
      value: maskSSN(data?.electionChoice ? data?.annuitantTaxId : data?.ssn),
      hide: !showSSN,
    },
    {
      label: "dob",
      value: data?.electionChoice
        ? formatDOB(data.annuitantBirthDate)
        : data?.dob,
    },
    {
      label: "gender",
      value: getGender(
        data?.electionChoice ? data?.annuitantGenderCode : data?.genderCode
      ),
    },
    {
      label: "address",
      value: data?.electionChoice
        ? data?.annuitantAddressLine1
        : data?.address1,
    },
    {
      label: "cityState",
      value: data?.electionChoice
        ? getAnnuitantCityStateZip(data)
        : getCityStateZip(data),
    },
    {
      label: "country",
      value:
        data?.usResident === "Y"
          ? labels?.dashboard?.unitedStates
          : data?.countryName || data?.pptStateCountryCode,
    },
    {
      label: "phone",
      value: data?.electionChoice ? data?.annuitantPhoneNumber : data?.mobile,
    },
    {
      label: "email",
      value: data?.electionChoice ? data?.annuitantEmailAddress : data?.email,
    },
  ];
};

const JointLifeInformation = ({ labels, data = {}, showSSN }) => {
  return (
    <div>
      {jointLifeInfo(data, showSSN).map((e, index) => {
        return !e.hide ? (
          <Row
            key={e.label + index}
            leftValue={labels[e.label]}
            rightValue={e.value}
          />
        ) : (
          <></>
        );
      })}
    </div>
  );
};

export default JointLifeInformation;
